import { gql } from '@apollo/client';

export const mutation = gql`
  mutation UpdateTag($id: uuid!, $label: String!) {
    update_tags_by_pk(pk_columns: { id: $id }, _set: { label: $label }) {
      id
      label
      type
    }
  }
`;

export function buildVariables({ id, label }) {
  return { id, label };
}
